// test1148
(1148 && 0);
